// import { GetStaticPaths, GetStaticProps, InferGetStaticPropsType } from "next";
// import NewProductOverview from "src/sections/product-overview/NewProductOverview";
// import MediaMentions from "src/sections/media-feedback/MediaMentions";
// import Layout from "src/sections/layout/Layout";
// import { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
// import { useTranslations } from "next-intl";
// import { Cart } from "src/types/storefront/Cart";
// import { Collection, Product } from "src/types/storefront";
// import NewAddToCartForm from "src/sections/product-overview/components/NewAddToCartForm";
// import { useRouter } from "next/router";
// import Container from "src/sections/container/Container";
// import reviewsPerProduct, { Review } from "src/config/reviewsPerProduct";
// import reviewsPerProductUSA from "src/config/reviewsPerProductUSA";
// import { CartContext, CartContextProps } from "src/context/cart";
// import getVariantQuantity from "src/helpers/storefront-helpers/getVariantQuantity";
// import getVariant from "src/helpers/inventory-helpers/getVariant";
// import { ParsedUrlQuery } from "querystring";
// import getFirstVariantAvailable from "src/helpers/inventory-helpers/getFirstVariantAvailable";
// import getCountryCodeFromLocale from "src/helpers/localization-helpers/getCountryCodeFromLocale";
// import useCountryCode from "src/hooks/useCountryCode";
// import { Locale } from "src/types/localization/Locale";
// import useCountryData from "src/hooks/useCountryData";
// import getProduct from "src/apis/storefront-latest-version/collections/getProduct";
// import { CollectionWithProductsHandles } from "src/types/storefront/CollectionWithProductsHandles";
// import getCollectionProductsHandles from "src/apis/storefront-latest-version/collections/getCollectionProductsHandles";
// import getDeployments from "src/helpers/localization-helpers/getDeployments";
// import Head from "next/head";
// import getVariantOptionsFromURL from "src/helpers/router-helpers/getVariantOptionsFromURL";
// import consts from "src/config/consts";
// import { ProductInternalData } from "src/types/shopify/ProductInternalData";
// import BlackSpinIcon from "src/components/icon/BlackSpinIcon";
// import HowDoesShemsiWork from "src/sections/product-overview/components/HowDoesShemsiWork";
// import ReviewsSection from "src/sections/product-overview/components/reviews/ReviewsSection";
// import ExploreShemsiCTASection from "src/sections/homepage/ExploreShemsiCTASection";
// import Country from "src/helpers/localization-helpers/countryClass";
// import countries from "src/config/countries/countries";
// import getCollectionById from "src/apis/storefront-latest-version/collections/getCollectionById";
// import structuredClone from "@ungap/structured-clone";
// import { captureException } from "@sentry/nextjs";
// import getTranslations from "src/helpers/localization-helpers/getTranslations";
// import addVariantParamsToQuery from "src/helpers/router-helpers/addVariantParamsToQuery";
// import ProductsListWithDesc from "src/sections/products-list/ProductsListWithDesc";
// import useMainProducts from "src/hooks/useMainProducts";

// function updateProductWithCartInventoryChanges(
//   cart: Cart,
//   oldProduct: Product,
//   setProduct: Dispatch<SetStateAction<Product>>
// ) {
//   setProduct((prevProduct) => {
//     if (!prevProduct) return prevProduct;

//     const newProduct = structuredClone(prevProduct);

//     newProduct.variants.forEach((variant) => {
//       const matchingCartItem = cart.lines.find((line) => line.merchandise.id === variant.id);

//       if (matchingCartItem) {
//         const quantityAvailable = getVariantQuantity(oldProduct, variant.id) - matchingCartItem.quantity;
//         variant.quantityAvailable = quantityAvailable < 0 ? 0 : quantityAvailable;
//       } else {
//         variant.quantityAvailable = getVariantQuantity(oldProduct, variant.id);
//       }
//     });

//     return newProduct;
//   });
// }
// function urlHasVariantOptions(query: ParsedUrlQuery): boolean {
//   const result = Object.keys(query).some((value) => consts.VARIANT_OPTIONS.includes(value));

//   return result;
// }

// async function validateProduct(
//   countryData: Country,
//   productHandleFromURL: string,
//   product: Product,
//   setProduct: Dispatch<SetStateAction<Product>>
// ) {
//   console.log("✅ validateProduct");
//   const isProductMismatch = productHandleFromURL !== product.handle;
//   const configCurrency = countryData.currency === "$" ? "USD" : countryData.currency;
//   const isCurrencyMismatch = product.variants[0].price.currencyCode !== configCurrency;

//   if (isProductMismatch || isCurrencyMismatch) {
//     console.log("💀 MISMATCH!", {
//       productHandleFromURL,
//       "product.handle": product.handle,
//       "product.variants[0].price.currencyCode": product.variants[0].price.currencyCode,
//       "countryData.currency": countryData.currency,
//     });
//     // captureException("✖ MISMATCH!");
//     try {
//       const correctProduct = await getProduct(productHandleFromURL, countryData.code);
//       setProduct(correctProduct);
//     } catch (error: any) {
//       captureException(error.message);
//     }
//   }
// }

function ProductPage() {
  // { product: serverProduct }: InferGetStaticPropsType<typeof getStaticProps>
  return <></>;
  // dependencies
  // const countryCode = useCountryCode();
  // const countryData = useCountryData();
  // const otherProducts = useMainProducts();

  // const t = useTranslations("Product");
  // const router = useRouter();

  // const [product, setProduct] = useState(serverProduct);
  // const [variantId, setVariantId] = useState("");
  // const [variantLoading, setVariantLoading] = useState(true);

  // const { cart } = useContext(CartContext) as CartContextProps;

  // // effects
  // /**
  //  * Syncs with product data that comes from the server (getStaticProps)
  //  */
  // useEffect(() => {
  //   setProduct(serverProduct);
  // }, [serverProduct]);

  // /**
  //  * Checks if product's currency is valid
  //  * if not, loads the correct product from Storefront
  //  */
  // useEffect(() => {
  //   const env = process.env.NEXT_PUBLIC_ENV;
  //   // The environment check is to prevent validating in staging environment as currency for all deployment is EGP
  //   if (countryData && router.query.productHandle && ["production", "preproduction"].includes(env)) {
  //     validateProduct(countryData, router.query.productHandle as string, product, setProduct);
  //   }
  // }, [product]);

  // useEffect(
  //   function setInitialUrlOptions() {
  //     if (product) {
  //       const options = getVariantOptionsFromURL(router.query);
  //       const variant = getVariant(product, options);

  //       if (options.length === 0 || !variant || variant.quantityAvailable <= 0) {
  //         const firstVariantAvailable = getFirstVariantAvailable(product, options);

  //         if (firstVariantAvailable) {
  //           addVariantParamsToQuery(router, firstVariantAvailable.selectedOptions);
  //         }
  //       }
  //     }
  //   },
  //   [router.query, product]
  // );

  // /**
  //  * Sets variant id from query options (if any exists)
  //  */
  // useEffect(
  //   function setVariantIdFromQuery() {
  //     if (urlHasVariantOptions(router.query) && product) {
  //       const options = getVariantOptionsFromURL(router.query);
  //       const variant = getVariant(product, options);
  //       if (variant && variant.quantityAvailable > 0) {
  //         setVariantId(variant.id);
  //       } else {
  //         setVariantId("");
  //       }
  //       setVariantLoading(false);
  //     }
  //   },
  //   [router.query, product]
  // );

  // /**
  //  * Syncs product's variants quantities with changes in the cart
  //  */
  // useEffect(() => {
  //   if (cart && serverProduct) {
  //     updateProductWithCartInventoryChanges(cart, serverProduct, setProduct);
  //   }
  // }, [cart]);

  // const variant = product?.variants.find((v) => v.id === variantId) || null;
  // let productInternalData: ProductInternalData | undefined;
  // let productReviews: Review[] = [];
  // if (product && countryData) {
  //   productInternalData = countryData.productsData.find((d) =>
  //     d.shopifyIds.find((d2) => product.id === `gid://shopify/Product/${d2}`)
  //   );
  //   productReviews =
  //     (countryCode === "US" ? reviewsPerProductUSA : reviewsPerProduct).find(
  //       (review) => productInternalData && review.internalProductName === productInternalData.internalName
  //     )?.reviews || [];
  // }

  // if (!product) {
  //   return (
  //     <Layout pageTitle={"Loading product page ..."} description={t("product_description")}>
  //       <Container>
  //         <div className="flex gap-x-2">
  //           <BlackSpinIcon />
  //           <p>{t("loading_product")}</p>
  //         </div>
  //       </Container>
  //     </Layout>
  //   );
  // }

  // return (
  //   <Layout
  //     pageTitle={product.title}
  //     description={t("product_description")}
  //     stickyFooterButtonTitle={t("get_product", {
  //       product_name: product.title,
  //     })}
  //     showStickyFooterPopUpButton={true}
  //     StickyFooterPopUpComponent={<NewAddToCartForm product={product} variantId={variantId} stickyFooter={true} />}
  //   >
  //     <Head>
  //       <meta httpEquiv="pragma" content="no-cache" />
  //       <meta httpEquiv="cache-control" content="no-cache, no-store, must-revalidate" />
  //     </Head>
  //     <Container className="pb-4 pt-3 sm:pb-4 sm:pt-3 lg:py-10">
  //       <section>
  //         <NewProductOverview product={product} variantId={variantId} variantLoading={variantLoading} />
  //       </section>
  //     </Container>
  //     <div className="bg-beige-50">
  //       <Container>
  //         <section>
  //           <MediaMentions />
  //         </section>
  //       </Container>
  //     </div>

  //     <Container>
  //       <HowDoesShemsiWork />
  //     </Container>

  //     {productReviews && (
  //       <Container>
  //         <ReviewsSection productReviews={productReviews} productHandle={product.handle} />
  //       </Container>
  //     )}

  //     <div className="bg-beige-400">
  //       <Container>
  //         <section className="flex flex-col items-center gap-8">
  //           <h2 className="text-2xl font-bold lg:text-3xl">{t("check_out_other_products")}</h2>
  //           <ProductsListWithDesc products={otherProducts} />
  //         </section>
  //       </Container>
  //     </div>

  //     {countryData?.bundleDiscountSystems && (
  //       <div className="py-10">
  //         <Container>
  //           <ExploreShemsiCTASection />
  //         </Container>
  //       </div>
  //     )}
  //   </Layout>
  // );
}

// export const getStaticPaths: GetStaticPaths = async ({ locales = [] }) => {
//   locales = locales.filter((locale) => locale !== "default");
//   /**
//    {
//     EG: Collection,
//     MA: Collection,
//     LB: Collection
//    }
//    */
//   const productHandlesByCountry: {
//     [x: string]: CollectionWithProductsHandles;
//   } = {};

//   for (const countryCode of getDeployments()) {
//     const collectionProductsHandles = await getCollectionProductsHandles(countryCode);
//     productHandlesByCountry[countryCode] = collectionProductsHandles;
//   }

//   return {
//     paths: locales
//       .map((locale) => {
//         const countryCode = getCountryCodeFromLocale(locale as Locale);
//         const collectionProductsHandles: CollectionWithProductsHandles = productHandlesByCountry[countryCode];
//         return collectionProductsHandles.products.map((product) => ({
//           params: { productHandle: product.handle },
//           locale,
//         }));
//       })
//       .flat(),
//     fallback: "blocking",
//     /**
//      * If fallback is 'blocking', new paths not returned by getStaticPaths will wait for the HTML to be generated, identical to SSR (hence why blocking),
//      * and then be cached for future requests so it only happens once per path.
//      */
//   };
// };

// export const getStaticProps: GetStaticProps<{
//   // product: Product;
//   // storeMetadata: Collection;
//   // newPriceCollection: Collection | null;
// }> = async ({ locale, params }) => {
//   if (!locale) {
//     throw new Error(`locale is not passed to getStaticProps`);
//   }

//   if (!(locale in Locale)) locale = Locale["ar-EG"];

//   if (!params || typeof params.productHandle !== "string") {
//     throw new Error(
//       `productHandle is not passed from getStaticPaths in [productHandle] page, params: ${JSON.stringify(params)}`
//     );
//   }

//   // Get store metadata
//   const countryCode = getCountryCodeFromLocale(locale as Locale);
//   const countryData = countries[countryCode];

//   // const storeMetadata = await getCollectionById(
//   //   countryCode,
//   //   countryData.collections.COLLECTION_ALL_ACTIVE_PRODUCTS.id,
//   //   true
//   // );
//   // let newPriceCollection: Collection | null = null;
//   // if (countryData.deploymentConfig.COLLECTION_NEW_PRICES) {
//   //   newPriceCollection = await getCollectionById(
//   //     countryData.code,
//   //     countryData.deploymentConfig.COLLECTION_NEW_PRICES,
//   //     true
//   //   );
//   // }

//   const translations = getTranslations(locale);

//   try {
//     // Get product
//     // const product = await getProduct(params.productHandle, countryCode);

//     return {
//       props: {
//         // product,
//         // storeMetadata,
//         // newPriceCollection,
//         translations,
//       },
//     };
//   } catch (error) {
//     return {
//       redirect: {
//         destination: "/shop-all",
//         permanent: false,
//       },
//     };
//   }
// };

export default ProductPage;
